'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ProjectDeleteSenderButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    deleteSenderLoading: state.project.deleteSenderLoading
  };
}, (0, _extends3.default)({}, projectActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectDeleteSenderButton, _Component);

  function ProjectDeleteSenderButton() {
    (0, _classCallCheck3.default)(this, ProjectDeleteSenderButton);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectDeleteSenderButton.__proto__ || (0, _getPrototypeOf2.default)(ProjectDeleteSenderButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectDeleteSenderButton, [{
    key: 'deleteSender',
    value: function deleteSender() {
      var _props = this.props,
          deleteSender = _props.deleteSender,
          projectId = _props.projectId,
          onDelete = _props.onDelete;

      return deleteSender({ projectId: projectId }).promise.then(onDelete).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          deleteSenderLoading = _props2.deleteSenderLoading;
      var t = this.context.t;


      return _react2.default.createElement(
        _Button2.default,
        {
          className: (0, _bind2.default)('btn-danger', className),
          onClick: this.deleteSender,
          loading: deleteSenderLoading
        },
        t('Delete')
      );
    }
  }]);
  return ProjectDeleteSenderButton;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  deleteSender: _propTypes2.default.func,
  deleteSenderLoading: _propTypes2.default.bool,
  onDelete: _propTypes2.default.func,
  projectId: _propTypes2.default.number
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onDelete: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'deleteSender', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteSender'), _class2.prototype)), _class2)) || _class);
exports.default = ProjectDeleteSenderButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectDeleteSenderButton/ProjectDeleteSenderButton.js
// module id = 2193
// module chunks = 1